<template>
    <!-- 普通签到 -->
    <section class="activity-box activity-box--ordinary" v-if="checkin.template == 0">
        <h1 class="activity-box__title">{{checkin.title}}</h1>

        <header class="activity-box__owner">
            <div class="activity-box__owner-main">
                <div class="activity-box__avatar">
                    <img v-if="ownerAvatar" class="activity-box__avatar-img" :src="ownerAvatar" />
                    <div v-else class="activity-box__avatar-placeholder">{{ ownerInitial }}</div>
                </div>
                <div class="activity-box__owner-info">
                    <div class="activity-box__owner-name" :style="{color:checkin.name_color?checkin.name_color:'#262626'}">
                        {{checkin.signature}}
                    </div>
                    <div class="activity-box__owner-cert-row">
                        <img @click="toCert" class="img_no_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220413/cc64dc95ff41c1f65590e20a8534191f.png" v-if="checkin.owner_cert_type==-1 && (checkin.is_owner == 1 )" />
                        <img class="img_no_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220413/b34dd9668a7b76530bfcec776d60b31a.png" v-if="checkin.owner_cert_type == -1 && checkin.is_owner == 0" />
                        <img class="img_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220126/b124c6878aa8908be741e3971dacece6.png" v-if="checkin.owner_cert_type==1" />
                        <img class="img_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220126/9043bea476e19b0e61f18a4e7398f341.png" v-if="checkin.owner_cert_type==0" />
                    </div>
                </div>
            </div>
            <button type="button" class="class-owner__msg-btn class-owner__msg-btn--launch-wrap" @click.stop="$emit('open-mini-tip', '请去「小小签到」小程序留言')">
                留言
                <wx-launch-weapp-trigger
                  v-if="enableWxLaunch"
                  :enabled="true"
                  :path="miniPath"
                  :appid="miniProgramAppId"
                  :username="miniProgramUsername"
                  template-width="100%"
                  template-height="25px"
                  :show-fallback="false"
                ></wx-launch-weapp-trigger>
            </button>
        </header>

        <div class="activity-box__meta">
            签到日期：
            <time :datetime="startDate">{{ startDate }}</time>
            至
            <time :datetime="endDate">{{ endDate }}</time>
        </div>
        <div v-if="checkin.checkinday[0] != 8 && checkin.checkinday[0] != 9 && showTimeLine" class="activity-box__meta">
            可签到时间：
            <span v-for="(item, index) in timeList" :key="index">{{ item[0] }}至{{ item[1] }} </span>
        </div>
        <div class="activity-box__meta">第{{checkin.days_current}}/{{checkin.days_length}}天 共{{checkin.join_num}}人参与</div>

        <div class="activity-box__meta" v-if="checkin.exchange_item.score > 0">
            签到积分：每次签到{{ checkin.exchange_item.score }}
        </div>

        <template v-if="richRules.length > 0 || plainRuleText">
            <div class="activity-box__meta activity-box__meta--desc">活动说明：</div>
            <activity-content :content="richRules" v-if="richRules.length > 0"></activity-content>
            <div class="activity-box__meta activity-box__meta--desc" v-else>{{ plainRuleText }}</div>
        </template>

        <section
          v-if="hasCheckinRequirements"
          class="activity-box__requirements"
          aria-label="签到要求"
        >
            <div
              ref="requirementsContent"
              :class="['activity-box__requirements-content', shouldCollapseRequirements && !requirementsExpanded ? 'activity-box__requirements-content--collapsed' : '']"
            >
                <div class="activity-box__require-title">签到要求：</div>
                <div v-if="hasWifiRequirements" class="activity-box__require-line">
                    需连接指定WIFI：
                    <span v-for="(item, index) in checkin.wifis" :key="`wifi-${index}`">{{ item.ssid }}{{ index != checkin.wifis.length - 1 ? '、' : '' }}</span>
                </div>
                <div v-if="hasLocationRequirements" class="activity-box__require-line">
                    需在指定地点：
                    <button
                      v-for="(item, index) in checkin.locations"
                      :key="`location-${index}`"
                      type="button"
                      class="activity-box__location-link"
                      @click.stop="openLocation(item)"
                    >{{ formatLocationText(item, index) }}</button>
                </div>
                <div v-if="checkin.scan_required == 1" class="activity-box__require-line">必须用微信「扫一扫」功能，对着二维码扫码打开签到活动页面才能签到。</div>
                <div v-if="checkin.scan_required == 2" class="activity-box__require-line">仅支持微信扫一扫动态码签到，二维码会定时刷新，过期后需重新扫码。</div>
            </div>
            <button
              v-if="showRequirementsToggle"
              type="button"
              class="activity-box__require-toggle"
              @click.stop="toggleRequirements"
            >{{ requirementsExpanded ? '点击收起 ↑' : '展开全部 ↓' }}</button>
        </section>
    </section>
    <!-- 会议签到 -->
    <section class="activity-box activity-box--ordinary" v-else-if="checkin.template == 1" aria-label="会议签到信息">
        <h1 class="activity-box__title">{{checkin.title}}</h1>

        <header class="activity-box__owner">
            <div class="activity-box__owner-main">
                <div class="activity-box__avatar">
                    <img v-if="ownerAvatar" class="activity-box__avatar-img" :src="ownerAvatar" />
                    <div v-else class="activity-box__avatar-placeholder">{{ ownerInitial }}</div>
                </div>
                <div class="activity-box__owner-info">
                    <div class="activity-box__owner-name" :style="{color:checkin.name_color?checkin.name_color:'#262626'}">
                        {{checkin.signature}}
                    </div>
                    <div class="activity-box__owner-cert-row">
                        <img @click="toCert" class="img_no_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220413/cc64dc95ff41c1f65590e20a8534191f.png" v-if="checkin.owner_cert_type==-1 && (checkin.is_owner == 1 )" />
                        <img class="img_no_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220413/b34dd9668a7b76530bfcec776d60b31a.png" v-if="checkin.owner_cert_type == -1 && checkin.is_owner == 0" />
                        <img class="img_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220126/b124c6878aa8908be741e3971dacece6.png" v-if="checkin.owner_cert_type==1" />
                        <img class="img_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220126/9043bea476e19b0e61f18a4e7398f341.png" v-if="checkin.owner_cert_type==0" />
                    </div>
                </div>
            </div>
            <button type="button" class="class-owner__msg-btn class-owner__msg-btn--launch-wrap" @click.stop="$emit('open-mini-tip', '请去「小小签到」小程序留言')">
                留言
                <wx-launch-weapp-trigger
                  v-if="enableWxLaunch"
                  :enabled="true"
                  :path="miniPath"
                  :appid="miniProgramAppId"
                  :username="miniProgramUsername"
                  template-width="100%"
                  template-height="25px"
                  :show-fallback="false"
                ></wx-launch-weapp-trigger>
            </button>
        </header>

        <div class="activity-box__meta">
            签到日期：
            <time :datetime="startDate">{{ startDate }}</time>
            至
            <time :datetime="endDate">{{ endDate }}</time>
        </div>
        <div v-if="checkin.checkinday[0] != 8 && checkin.checkinday[0] != 9 && showTimeLine" class="activity-box__meta">
            可签到时间：
            <span v-for="(item, index) in timeList" :key="index">{{ item[0] }}至{{ item[1] }} </span>
        </div>
        <div class="activity-box__meta">第{{checkin.days_current}}/{{checkin.days_length}}天 共{{checkin.join_num}}人参与</div>

        <div class="activity-box__meta" v-if="checkin.exchange_item.score > 0">
            签到积分：每次签到{{ checkin.exchange_item.score }}积分
        </div>

        <template v-if="checkin.rule">
            <div class="activity-box__meta activity-box__meta--desc">活动规则：</div>
            <div class="activity-box__meta activity-box__meta--desc text-pre-line">{{ checkin.rule }}</div>
        </template>
        <div class="activity-box__meta" v-if="checkin.joined_tip">
            参与须知：{{checkin.joined_tip}}
        </div>
    </section>
    <!-- 班级签到 -->
    <section class="flex-column padding-20-30" style="background-color: #fff;" v-else-if="checkin.template == 2" aria-label="班级签到信息">
        <div class="top-10">
            <h1 class="class-title">{{checkin.title}}</h1>
        </div>
        <div class="class-owner top-10">
            <div class="class-owner__left">
                <div class="class-owner__avatar">
                    <img v-if="ownerAvatar" class="class-owner__avatar-img" :src="ownerAvatar" />
                    <div v-else class="class-owner__avatar-placeholder">{{ ownerInitial }}</div>
                </div>
                <div class="class-owner__meta">
                    <div class="class-owner__name" :style="{color:checkin.name_color?checkin.name_color:'#262626'}">{{checkin.signature}}</div>
                    <div class="class-owner__cert-row">
                        <img class="img_no_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220413/b34dd9668a7b76530bfcec776d60b31a.png" v-if="checkin.owner_cert_type == -1" />
                        <img class="img_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220126/b124c6878aa8908be741e3971dacece6.png" v-if="checkin.owner_cert_type==1" />
                        <img class="img_cer" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220126/9043bea476e19b0e61f18a4e7398f341.png" v-if="checkin.owner_cert_type==0" />
                    </div>
                </div>
            </div>
            <button type="button" class="class-owner__msg-btn class-owner__msg-btn--launch-wrap" @click.stop="$emit('open-mini-tip', '请去「小小签到」小程序留言')">
                留言
                <wx-launch-weapp-trigger
                  v-if="enableWxLaunch"
                  :enabled="true"
                  :path="miniPath"
                  :appid="miniProgramAppId"
                  :username="miniProgramUsername"
                  template-width="100%"
                  template-height="25px"
                  :show-fallback="false"
                ></wx-launch-weapp-trigger>
            </button>
        </div>
        <div class="top-10">
            <span class="text-28-99">
                班级日期：
                <time :datetime="startDate">{{ startDate }}</time>
                至
                <time :datetime="endDate">{{ endDate }}</time>
            </span>
        </div>
        <div class="top-10" v-if="checkin.rule">
            <span class="text-28-99">班级说明：</span>
            <p class="text-28-99 text-pre-line">{{checkin.rule}}</p>
        </div>
        <div class="top-10" v-if="checkin.joined_tip">
            <span class="text-28-99">参与须知{{checkin.joined_tip}}</span>
        </div>
    </section>
</template>
<script>
import {
  getTimeString,
  formatDate
} from "@/utils/common.js";
import ActivityContent from '@/components/ActivityContent.vue'
import WxLaunchWeappTrigger from '@/components/WxLaunchWeappTrigger.vue'
export default {
   name: '',
   props:{
       checkin:{
           type: Object,
           default: null
       },
       enableWxLaunch: {
           type: Boolean,
           default: false
       },
       miniPath: {
           type: String,
           default: ''
       },
       miniProgramAppId: {
           type: String,
           default: 'wxee55405953922c86'
       },
       miniProgramUsername: {
           type: String,
           default: 'gh_eedd8c096654'
       },
   },
   components:{
       'activity-content': ActivityContent,
       WxLaunchWeappTrigger
   },
   data() {
       return {
           // requirementsExpanded 控制签到要求超过三行时的展开/收起状态。
           requirementsExpanded: true,
           // shouldCollapseRequirements 表示签到要求真实内容超过折叠高度，需要展示展开/收起按钮。
           shouldCollapseRequirements: false
       }
   },
   computed:{
       showTimeLine() {
           if(this.checkin.time_list) {
               if( getTimeString(this.checkin.time_list[0][0]) == "00:00" && getTimeString(this.checkin.time_list[0][1]) == "23:59") {
                   return false;
               }else {
                   return true
               }
           }
           return false
       },
       timeList() {
           if(this.checkin.time_list) {
               let timeList = this.checkin.time_list.map(item=>{
                   item[0] = getTimeString(item[0])
                   item[1] = getTimeString(item[1])
                   return item
               })
               return timeList
           }
           return []
       },
       hasWifiRequirements() {
           return !!this.checkin && Array.isArray(this.checkin.wifis) && this.checkin.wifis.length > 0
       },
       hasLocationRequirements() {
           return !!this.checkin && Array.isArray(this.checkin.locations) && this.checkin.locations.length > 0
       },
       hasScanRequirements() {
           return !!this.checkin && (this.checkin.scan_required == 1 || this.checkin.scan_required == 2)
       },
       hasCheckinRequirements() {
           return this.hasWifiRequirements || this.hasLocationRequirements || this.hasScanRequirements
       },
       requirementLineCount() {
           let count = 0
           if (this.hasWifiRequirements) count += 1
           if (this.hasLocationRequirements) count += this.checkin.locations.length
           if (this.hasScanRequirements) count += 1
           return count
       },
       showRequirementsToggle() {
           return this.hasCheckinRequirements && this.shouldCollapseRequirements
       },
       startDate() {
           if (this.checkin.start_date) {
               return formatDate( new Date(this.checkin.start_date * 1000),"yyyy-MM-dd")
           }
           return ''
       },
       endDate() {
           if(this.checkin.end_date) {
               return formatDate(new Date(this.checkin.end_date * 1000), "yyyy-MM-dd");
           }
           return ""
       },
       ownerAvatar() {
           return this.checkin.avatar || this.checkin.owner_upic || this.checkin.upic || this.checkin.head_url || this.checkin.user_avatar || ''
       },
       ownerInitial() {
           return this.checkin.signature ? this.checkin.signature.slice(0, 1) : '签'
       },
       plainRuleText() {
           if (!Array.isArray(this.checkin.rules) || this.checkin.rules.length === 0) {
               return this.checkin.rule || ''
           }
           const textList = this.checkin.rules
               .filter(item => item && item.type == 'text' && item.value)
               .map(item => item.value)
               .filter(Boolean)
           return textList.join(' ')
       },
       richRules() {
           if (!Array.isArray(this.checkin.rules)) {
               return []
           }
           return this.checkin.rules.filter(item => this.hasRuleContent(item))
       }
   },
   watch: {
      /**
       * 监听签到活动数据切换，重新测量签到要求区是否需要折叠。
       *
       * @returns {void}
       */
      checkin() {
        this.requirementsExpanded = true
        this.shouldCollapseRequirements = false
        this.measureRequirementsOverflow()
      }
   },
   mounted() {
      this.measureRequirementsOverflow()
   },
   updated() {
      this.measureRequirementsOverflow()
   },
   methods: {
      hasRuleContent(item) {
        if (!item || !item.type) {
          return false
        }
        if (item.type == 'text' || item.type == 'img') {
          return !!item.value
        }
        if (item.type == 'video') {
          return !!(item.url || item.url_play)
        }
        if (item.type == 'audio') {
          return !!item.url
        }
        if (item.type == 'article') {
          return !!(item.mp_title || item.mp_url)
        }
        if (item.type == 'file') {
          return !!(item.file_name || item.file_url)
        }
        return !!item.value
      },
      /**
       * 组合单个指定地点展示文案，保持与小程序“地址 + 范围米”一致。
       *
       * @param {Object} location 详情接口返回的地点配置。
       * @param {number} index 当前地点在列表中的序号。
       * @returns {string} 用于页面展示的地点要求文案。
       */
      formatLocationText(location, index) {
        const address = location && location.address ? location.address : '指定地点'
        const range = location && location.range ? ` ${location.range}米` : ''
        const suffix = index != this.checkin.locations.length - 1 ? '、' : ''
        return `${address}${range}${suffix}`
      },
      /**
       * 打开地图查看指定签到地点，H5 使用腾讯地图 URI 方案承接小程序 openLocation 行为。
       *
       * @param {Object} location 详情接口返回的地点配置，需包含 latitude 与 longitude。
       * @returns {void}
       */
      openLocation(location) {
        const latitude = Number(location && location.latitude)
        const longitude = Number(location && location.longitude)
        const address = location && location.address ? location.address : '签到地点'
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
          this.$emit('open-mini-tip', '请去「小小签到」小程序查看签到地点')
          return
        }
        // 腾讯地图 URI 可在移动浏览器和桌面浏览器打开地点标记，作为 wx.openLocation 的 H5 替代。
        const marker = `coord:${latitude},${longitude};title:${encodeURIComponent(address)}`
        const mapUrl = `https://apis.map.qq.com/uri/v1/marker?marker=${marker}&referer=xiaoqiandao`
        window.open(mapUrl, '_blank')
      },
      /**
       * 切换签到要求折叠状态。
       *
       * @returns {void}
       */
      toggleRequirements() {
        this.requirementsExpanded = !this.requirementsExpanded
      },
      /**
       * 测量签到要求真实高度，只有内容超过三行高度时才启用折叠。
       *
       * @returns {void}
       */
      measureRequirementsOverflow() {
        this.$nextTick(() => {
          const box = this.$refs.requirementsContent
          if (!box) {
            return
          }
          const fontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 37.5
          // 小程序只折叠正文内容，126rpx 对应三行正文高度，不包含外层容器 padding。
          const collapsedHeight = 126 / 75 * fontSize
          const needCollapse = box.scrollHeight > collapsedHeight + 1
          if (needCollapse !== this.shouldCollapseRequirements) {
            this.shouldCollapseRequirements = needCollapse
            this.requirementsExpanded = !needCollapse
          }
        })
      },
      toCert() {
        this.$router.replace({ name: 'certStatus', query: { showqr: '1' } })
      }
      
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}
.activity-box {
  padding: rem(24) rem(30) rem(28);
  background: #fff;
}

.activity-box--ordinary {
  .activity-box__title {
    margin: 0;
    font-size: rem(44);
    line-height: 1.45;
    color: #262626;
    font-weight: 700;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .activity-box__owner {
    margin-top: rem(22);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: rem(20);
  }

  .activity-box__owner-main {
    min-width: 0;
    display: flex;
    align-items: center;
    flex: 1;
  }

  .activity-box__avatar {
    width: rem(72);
    height: rem(72);
    border-radius: 50%;
    overflow: hidden;
    flex: 0 0 auto;
    background: linear-gradient(135deg, #ffd7ba, #f0a96e);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .activity-box__avatar-img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .activity-box__avatar-placeholder {
    color: #ffffff;
    font-size: rem(28);
    font-weight: 700;
  }

  .activity-box__owner-info {
    min-width: 0;
    margin-left: rem(16);
  }

  .activity-box__owner-name {
    font-size: rem(34);
    line-height: 1.3;
    color: #262626;
    font-weight: 600;
    word-break: break-word;
  }

  .activity-box__owner-cert-row {
    margin-top: rem(8);
    display: flex;
    align-items: center;
  }

  .activity-box__meta {
    margin-top: rem(10);
    font-size: rem(28);
    line-height: 1.45;
    color: #262626;
    word-break: break-word;
  }

  .activity-box__meta--desc {
    margin-top: rem(16);
  }

  .activity-box__requirements {
    margin: rem(28) rem(-30) 0;
    padding: rem(18) rem(30);
    background: #f5f5f8;
    box-sizing: border-box;
    color: #999;
    font-size: rem(28);
    line-height: rem(42);
  }

  .activity-box__requirements-content--collapsed {
    max-height: rem(126);
    overflow: hidden;
  }

  .activity-box__require-title {
    font-weight: 600;
  }

  .activity-box__require-line {
    word-break: break-word;
  }

  .activity-box__location-link {
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    line-height: inherit;
    text-align: left;
    word-break: break-word;
    cursor: pointer;
  }

  .activity-box__require-toggle {
    margin: rem(8) 0 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: #12b7f5;
    font-size: rem(28);
    line-height: rem(42);
    cursor: pointer;
  }
}

.icon-30-28 {
  width: rem(30);
  height: rem(28);
  margin-right: rem(10);
}
.text-30-black {
  font-size: rem(30);
  color: #333;
}
.top-10 {
  margin-top: rem(10);
}
.text-28-99 {
  margin: 0;
  font-size: rem(28);
  color: #262626;
}
.text-pre-line {
  white-space: pre-line;
}

.class-owner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.class-owner__left {
  min-width: 0;
  display: flex;
  align-items: center;
}

.class-owner__avatar {
  width: rem(72);
  height: rem(72);
  border-radius: 50%;
  overflow: hidden;
  flex: 0 0 auto;
  background: linear-gradient(135deg, #ffd7ba, #f0a96e);
  display: flex;
  align-items: center;
  justify-content: center;
}

.class-owner__avatar-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.class-owner__avatar-placeholder {
  color: #fff;
  font-size: rem(28);
  font-weight: 700;
}

.class-owner__meta {
  min-width: 0;
  margin-left: rem(16);
}

.class-owner__name {
  font-size: rem(34);
  line-height: 1.3;
  color: #262626;
  font-weight: 600;
  word-break: break-word;
}

.class-owner__cert-row {
  margin-top: rem(8);
  display: flex;
  align-items: center;
}

.class-owner__msg-btn {
  position: relative;
  width: rem(100);
  height: rem(50);
  border: 1px solid #33a8ef;
  border-radius: rem(30);
  color: #33a8ef;
  background: transparent;
  font-size: rem(26);
  cursor: pointer;
}

.class-owner__msg-btn--launch-wrap {
  overflow: hidden;
}
.title {
  font-size: rem(44);
  color: #262626;
  font-weight: bold;
}
.class-title {
  font-size: rem(44);
  line-height: 1.45;
  color: #262626;
  font-weight: 700;
}
.img_no_cer {
  width: rem(114);
  height: rem(34);
}
.img_cer {
  width: rem(124);
  height: rem(34);
}
.max {
  max-width: rem(680);
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/ActivityBox.vue